import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'WE',
    name: 'Riss-Furie',
    id: 'GateWitch',
    health: 70,
    difficulty: 7,
    expeditionRating: 4,
    additionalInfo: '',
  },
  {
    expansion: 'WE',
    name: 'Krone der Leere',
    id: 'HollowCrown',
    health: 1,
    difficulty: 5,
    expeditionRating: 3,
    additionalInfo: '',
  },
  {
    expansion: 'WE',
    name: 'Schattenmantel-Magus',
    id: 'MagusOfCloaks',
    health: 35,
    difficulty: 7,
    expeditionRating: 3,
    additionalInfo: '',
  },
  {
    expansion: 'WE',
    name: 'Schatten-Titan',
    id: 'UmbraTitan',
    health: 70,
    difficulty: 3,
    expeditionRating: 1,
    additionalInfo: '',
  },
]
